<div *ngFor="let material of materialCatalogueList$ | async; let i = index">
  <ion-card
    #materialRow
    [ngClass]="{ 'selected-item': i === (selectedIndex$ | async) }"
    class="card-list-item">
    <ion-card-content
      (click)="onClick(material)"
      (keydown.enter)="onClick(material)"
      (mouseover)="onHover(i)">
      <div *ngFor="let col of tableColumns$ | async">
        <div *ngIf="col.selected">
          <ion-label class="admia-list-item-title">
            {{ (col.text | translate) + ': ' }}
          </ion-label>
          <ion-text>{{ material[col.name] }}</ion-text>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
